import {
  restApiService,
} from '../../services/services';
import {
  handleAxiosResponse,
} from '../../util/apiHelpers';
import {
  axiosStorableError,
} from '../../util/errors';

const SAVE_SAVED_SEARCH = 'app/SavedSearchModal/SAVE_SAVED_SEARCH';
const SAVE_SAVED_SEARCH_SUCCESS = 'app/SavedSearchModal/SAVE_SAVED_SEARCH_SUCCESS';
const SAVE_SAVED_SEARCH_ERROR = 'app/SavedSearchModal/SAVE_SAVED_SEARCH_ERROR';

const OPEN_SET = 'app/SavedSearchModal/OPEN_SET';
const CLEAR_STATE = 'app/SavedSearchModal/CLEAR_STATE';

const initialState = {
  isOpen: false,
  saveSavedSearchInProgress: false,
  saveSavedSearchError: null,
  successText: null,
};

export default function saveSearchModalReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case OPEN_SET:
      return {
        ...initialState,
        isOpen: payload,
      };

    case SAVE_SAVED_SEARCH:
      return {
        ...state,
        saveSavedSearchInProgress: true,
        saveSavedSearchError: null,
        successText: null,
      };

    case SAVE_SAVED_SEARCH_SUCCESS:
      return {
        ...state,
        saveSavedSearchInProgress: false,
        successText: payload,
      };

    case SAVE_SAVED_SEARCH_ERROR:
      return {
        ...state,
        saveSavedSearchInProgress: false,
        saveSavedSearchError: payload,
        successText: null,
      };

    case CLEAR_STATE:
      return initialState;

    default:
      return state;
  }
}

const openSet = val => ({
  type: OPEN_SET,
  payload: val,
});

const saveSavedSearchAction = () => ({
  type: SAVE_SAVED_SEARCH,
});

const saveSavedSearchSuccess = successText => ({
  type: SAVE_SAVED_SEARCH_SUCCESS,
  payload: successText,
});

const saveSavedSearchError = error => ({
  type: SAVE_SAVED_SEARCH_ERROR,
  payload: error,
});

const clearState = () => ({
  type: CLEAR_STATE,
});

const $saveSearchModalState = state => {
  return state.SaveSearchModal;
};

export const $saveSavedSearchState = state => {
  const subState = $saveSearchModalState(state);
  return {
    inProgress: subState.saveSavedSearchInProgress,
    successText: subState.successText,
    error: subState.saveSavedSearchError,
  };
};

export const $isOpen = state => {
  const subState = $saveSearchModalState(state);
  return subState.isOpen;
};

export const openModal = () => dispatch => {
  dispatch(openSet(true));
};

export const closeModal = () => dispatch => {
  dispatch(openSet(false));
};

export const addSavedSearch = (listingType, userId, values) => dispatch => {
  dispatch(saveSavedSearchAction());
  const search = window.location.search;
  const searchObj = Object.fromEntries(new URLSearchParams(search));
  return restApiService.secureInstance
    .postRaw('/savedSearches', {
      listingType,
      userId,
      name: values.name,
      freq: values.freq,
      searchObj,
      toEmail: values.toEmail,
      toSms: values.toSms,
    })
    .then(handleAxiosResponse)
    .then(savedSearches => {
      const successText =
        values.toSms || values.toEmail
          ? "Search saved. We'll notify you when a new listing matches your search"
          : "Search has been saved"
      ;
      dispatch(saveSavedSearchSuccess(successText));
      return savedSearches;
    })
    .catch(e => {
      dispatch(saveSavedSearchError(axiosStorableError(e).message));
      throw e;
    })
  ;
};

export const updateSavedSearch = (prevItem, updatedItem) => dispatch => {
  dispatch(saveSavedSearchAction());
  return restApiService.secureInstance
    .postRaw(`savedSearches/${updatedItem.id}`, {
      name: updatedItem.name,
      freq: updatedItem.freq,
      toEmail: updatedItem.toEmail,
      toSms: updatedItem.toSms,
    })
    .then(handleAxiosResponse)
    .then(item => {
      const successText = ((prevItem.toSms !== updatedItem.toSms)
        || (prevItem.toEmail !== updatedItem.toEmail) && (updatedItem.toSms || updatedItem.toEmail))
        ? "Search saved. We'll notify you when a new listing matches your search"
        : "Search has been saved"
      ;
      dispatch(saveSavedSearchSuccess(successText));
      return item;
    })
    .catch(e => {
      dispatch(saveSavedSearchError(axiosStorableError(e).message));
      throw e;
    })
  ;
};

export const resetState = () => dispatch => {
  dispatch(clearState());
};

